module.exports = __webpack_public_path__ + "static/media/johnmonash.a0d52135.jpeg";